"use strict";

define('app/study/list/study.list.view',['rs/abstract.content.view', 'rs/components/scroll-bottom', 'rs/helper', 'rs/components/pagination/pagination', 'rs/components/select', 'rs/collection.mapper'], function (AbstractContentView, ScrollBottom, helper, PaginationView, SelectView, CollectionMapper) {
  var StudyListView = AbstractContentView.extend({
    events: {
      'click .filter-clear': 'handleFilterClearBtnClick',
      'keyup .filter-input': 'handleFilterInputKeyup',
      'click .btn-search': 'handleFilterSubmit',
      'enterkey .study-name': 'handleStudyNameEnterKey',
      'click .study-tabs .tab-item': 'handleStudyTabClick',
      'click .new-study-btn': 'handleNewStudyClick',
      'click .btn-cancel-create-study': 'handleCancelCreateStudy',
      'click .btn-save-create-study': 'handleSaveCreateStudy',
      'click .filter-property': 'handleFilterPopup',
      'click .popover': 'handlePopoverClick',
      'click .filter-option-chkbx': 'handleFilterChange'
    },
    templates: {
      'study.list.init': 'renderInitFragment',
      'filter.popup': 'renderFilterPopup',
      'filter.option': 'renderFilterOption'
    },
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.paginationView = new PaginationView();
      this.selectView = new SelectView({
        className: 'form-control'
      });
      this.listenTo(this.paginationView, 'page:select', function (page) {
        this.getDelegate().getCurrentPaginate().setPage(page);
      });
      this.listenTo(this.paginationView, 'action:next', function () {
        this.getDelegate().getCurrentPaginate().next();
      });
      this.listenTo(this.paginationView, 'action:prev', function () {
        this.getDelegate().getCurrentPaginate().previous();
      });
      this.paginationView.$el.addClass('pull-right');
    },
    watchDelegateProperties: function watchDelegateProperties() {
      var delegate = this.getDelegate(),
        paginate = null;
      function bindPaginate() {
        if (paginate) {
          this.stopListening(paginate);
        }
        paginate = delegate.getCurrentPaginate();
        var onFiltersChange = _.bind(this.onPaginateFiltersChange, this, paginate),
          count = this.$('.item-count'),
          fn = null;
        this.listenTo(paginate, 'change:filters', onFiltersChange);
        this.listenTo(paginate, 'change:totalItems change:totalPageItems change:page', fn = function fn() {
          var range = paginate.itemRange();
          if (paginate.getTotalPageItems() && paginate.getTotalItems()) {
            count.text(range[0] + '-' + range[1] + ' of ' + paginate.getTotalItems());
          } else {
            count.text('');
          }
        });
        fn.call(this);
        onFiltersChange();
      }
      ;
      this.selectView.render(CollectionMapper.map(delegate.pageCountOptions).attr('count', 'value').attr('count', 'text').duplex(true).attr('selected').collection());
      this.listenTo(this, 'change:rendered', function () {
        this.listenTo(delegate, 'change:selectedTab', bindPaginate);
        bindPaginate.call(this);
      });
    },
    onPaginateFiltersChange: function onPaginateFiltersChange(paginate) {
      var filters = this.getDelegate().propertyFilters;
      _.each(filters, function (filter, index) {
        if (paginate.hasFilter(filter.field)) {
          this.addActiveFilterClass(index);
        } else {
          this.removeActiveFilterClass(index);
        }
      }, this);
    },
    render: function render() {
      var delegate = this.getDelegate(),
        data = delegate.getTemplateProperties();
      this.$el.html(this.renderInitFragment(data));
      this.$('.pagination-container').append(this.paginationView.$el.css('margin-top', -20));
      this.$('#count-select').replaceWith(this.selectView.$el);
      this._super();
    },
    renderPages: function renderPages(pages) {
      this.paginationView.render(pages);
    },
    setupScrolling: function setupScrolling() {
      var scroll = ScrollBottom(window, _.bind(this.didReachScrollBottom, this));
      this.once('destroy', scroll.remove);
    },
    resetScroll: function resetScroll() {
      $(window).scrollTop(0);
    },
    didReachScrollBottom: function didReachScrollBottom(el, ev) {
      this.getDelegate().trigger('scroll:bottom');
    },
    closeCreateStudy: function closeCreateStudy() {
      this.showStudyNameSuccess();
      this.getNewStudyForm().slideUp();
    },
    getStudyName: function getStudyName() {
      return this.$('.study-name').val();
    },
    getNewStudyForm: function getNewStudyForm() {
      return this.$('.form-new-study');
    },
    showStudyNameSuccess: function showStudyNameSuccess() {
      this.$('.study-name-error').slideUp();
    },
    showStudyNameError: function showStudyNameError(message) {
      this.$('.study-name-error').find('.error-message').text(message).end().slideDown();
    },
    emptyClearStudyData: function emptyClearStudyData() {
      this.$('.study-name').val('');
    },
    openCreateStudy: function openCreateStudy() {
      $(document.body).scrollTop(0);
      this.getNewStudyForm().slideDown();
      this.$('.study-name').focus();
    },
    selectTabByName: function selectTabByName(name) {
      var container = this.$('.tab-container.study-tabs');
      this.selectItemByName(container, name);
    },
    selectItemByName: function selectItemByName(container, name) {
      container.find('.active').removeClass('active');
      container.find('[data-name="' + name + '"]').addClass('active');
    },
    getTableElement: function getTableElement() {
      return this.$('.study-list-grid-container');
    },
    handleFilterPopup: function handleFilterPopup(ev) {
      if (!ev.currentTarget._showingFilters) {
        var el = $(ev.currentTarget),
          delegate = this.getDelegate(),
          index = el.data('index'),
          filter = delegate.propertyFilters[index],
          filterOptions = delegate[filter.options],
          paginate = delegate.getCurrentPaginate(),
          html = this.renderFilterPopup({
            index: index
          }),
          that = this;
        if (!filterOptions.length) {
          return;
        }
        for (var j = 0; j < filterOptions.length; j++) {
          var option = filterOptions[j],
            data = {
              text: option,
              displayName: option,
              index: j,
              parentIndex: el.data('index'),
              checked: paginate.getFilterByName(filter.field).indexOf(option) > -1
            };
          html.children().find('ul').append(this.renderFilterOption(data));
        }
        el.get(0)._showingFilters = true;
        el.popover({
          animation: true,
          delay: 0,
          content: html,
          html: true,
          placement: 'bottom'
        }).popover('show');
        this.$('.popover').css('left', el.position().left - 10);
        _.defer(function () {
          $(document.body).on('click', function (ev) {
            el.popover('destroy');
            el.get(0)._showingFilters = false;
            $(this).off(ev);
          });
        });
      }
    },
    handleFilterChange: function handleFilterChange(ev) {
      var el = $(ev.currentTarget),
        value = el.data('value'),
        index = el.parents('.filter-options').data('index');
      this.getDelegate().propertyFilterDidChange(index, value, ev.currentTarget.checked);
    },
    handlePopoverClick: function handlePopoverClick(ev) {
      ev.stopPropagation();
    },
    handleNewStudyClick: function handleNewStudyClick() {
      this.openCreateStudy();
    },
    handleStudyTabClick: function handleStudyTabClick(ev) {
      var el = $(ev.currentTarget),
        index = el.data('index');
      this.toggleFilters(index);
      this.getDelegate().setTabByIndex(index);
    },
    toggleFilters: function toggleFilters(index) {
      index = index ? parseInt(index) : 0;
      switch (index) {
        case 0:
          this.showAssignmentFilter([0, 1]);
          break;
        default:
          this.showAssignmentFilter([2]);
      }
    },
    addActiveFilterClass: function addActiveFilterClass(index) {
      this.$('.filter-property[data-index="' + index + '"]').addClass('active');
    },
    removeActiveFilterClass: function removeActiveFilterClass(index) {
      this.$('.filter-property[data-index="' + index + '"]').removeClass('active');
    },
    showAssignmentFilter: function showAssignmentFilter(indices) {
      var filters = this.getDelegate().propertyFilters;
      for (var j = 0, len = filters.length; j < len; j++) {
        if (indices.indexOf(j) > -1) {
          this.$('.filter-property[data-index="' + j + '"]').show();
        } else {
          this.$('.filter-property[data-index="' + j + '"]').hide();
        }
      }
    },
    setQueryString: function setQueryString(str) {
      if (this.isRendered()) {
        this.$('.filter-input').val(str);
        this.refreshFilterClearVisibility(str);
      } else {
        this.listenToOnce(this, 'change:rendered', _.bind(this.setQueryString, this, str));
      }
    },
    clearFilterInput: function clearFilterInput() {
      this.$('.filter-input').val('');
      this.refreshFilterClearVisibility('');
      this.getDelegate().requestFilterText('');
    },
    submitFilterText: function submitFilterText() {
      var el = this.$('.filter-input'),
        text = el.val();
      this.getDelegate().requestFilterText(text);
    },
    handleFilterSubmit: function handleFilterSubmit() {
      this.submitFilterText();
    },
    handleFilterInputKeyup: function handleFilterInputKeyup(ev) {
      var el = $(ev.currentTarget),
        text = el.val();
      if (ev.keyCode == 13) {
        this.submitFilterText();
      }
      if (ev.keyCode == 27) {
        this.clearFilterInput();
      } else {
        this.refreshFilterClearVisibility(text);
      }
    },
    refreshFilterClearVisibility: function refreshFilterClearVisibility(text) {
      if (String(text || '').length) {
        this.$('.filter-clear').css('visibility', 'visible');
      } else {
        this.$('.filter-clear').css('visibility', 'hidden');
      }
    },
    hidePageSize: function hidePageSize() {
      this.$('.page-count-select-container').hide();
    },
    showPageSize: function showPageSize() {
      this.$('.page-count-select-container').show();
    },
    handleFilterClearBtnClick: function handleFilterClearBtnClick() {
      this.clearFilterInput();
    },
    handleCancelCreateStudy: function handleCancelCreateStudy() {
      this.getDelegate().closeCreateStudy();
    },
    handleStudyNameEnterKey: function handleStudyNameEnterKey() {
      this.handleSaveCreateStudy();
    },
    handleSaveCreateStudy: function handleSaveCreateStudy() {
      var name = this.$('.study-name').val();
      this.getDelegate().requestCreateStudy(name);
    }
  });
  return StudyListView;
});

